import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const updateVisit = async ({ trialId, patientId, payload }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (!!patientId) params.append("patient_id", patientId);

  // Default visit name fallback
  if (!payload.visit_name) {
    switch (payload.visit_number) {
      case 0:
        payload.visit_name = "Baseline Visit";
        break;
      case -3:
        payload.visit_name = "Screening Visit";
        break;
      case -4:
        payload.visit_name = "Other Ecrfs";
        break;
      case -1:
        payload.visit_name = "Adverse Event";
        break;
      case -2:
        payload.visit_name = "Unscheduled Event";
        break;
      default:
        break;
    }
  }

  const URL = `${__API_URL__}/api/photos/update_visits/${trialId}/?${params.toString()}`;

  const response = await axios.patch(URL, payload, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useUpdateVisitMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateVisit,
    onSuccess: (_data, { trialId }) => {
      queryClient.invalidateQueries({ queryKey: ["visits"] });
      queryClient.invalidateQueries({ queryKey: ["visit_details", trialId] });
      queryClient.invalidateQueries({ queryKey: ["visits_status_dropdown"] });
    },
  });
};

export default useUpdateVisitMutation;
